import { EditarPontoFisicoComponent } from '../ponto-fisico/editar-ponto-fisico/editar-ponto-fisico.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { routing } from './../rotas';
import { PipesModule } from './filtros/pipes/pipes.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ComumService } from './comum.service';
import { ComumHttpService } from './comum-http.service';

import { TelefoneComponent } from './components/telefone/telefone.component';
import { FormTelefoneComponent } from './components/form-telefone/form-telefone.component';
import { CadastroTelefoneComponent } from './components/cadastro-telefone/cadastro-telefone.component';
import { EditarTelefoneComponent } from './components/editar-telefone/editar-telefone.component';

import { EnderecoComponent } from './components/endereco/endereco.component';
import { FormEnderecoComponent } from './components/form-endereco/form-endereco.component';
import { CadastroEnderecoComponent } from './components/cadastro-endereco/cadastro-endereco.component';
import { EditarEnderecoComponent } from './components/editar-endereco/editar-endereco.component';

import { AreaComponent } from './components/area/area.component';
import { FormPontoFisicoComponent } from './components/form-ponto-fisico/form-ponto-fisico.component';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { CadastroAreaComponent } from './components/cadastro-area/cadastro-area.component';
import { FormAreaComponent } from './components/form-area/form-area.component';
import { EditarAreaComponent } from './components/editar-area/editar-area.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TextMaskModule,
    NgxPaginationModule,
    NgbModule,
    PipesModule,
    routing,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    })
  ],
  declarations: [
    TelefoneComponent, CadastroTelefoneComponent, EditarTelefoneComponent, FormTelefoneComponent, EnderecoComponent,
    CadastroEnderecoComponent, EditarEnderecoComponent, FormEnderecoComponent, FormPontoFisicoComponent, EditarPontoFisicoComponent,
    AreaComponent, CadastroAreaComponent, FormAreaComponent, EditarAreaComponent],
  exports: [
    TelefoneComponent, CadastroTelefoneComponent, EditarTelefoneComponent, FormTelefoneComponent, EnderecoComponent,
    CadastroEnderecoComponent, EditarEnderecoComponent, FormEnderecoComponent, FormPontoFisicoComponent, EditarPontoFisicoComponent,
    AreaComponent, CadastroAreaComponent, FormAreaComponent, EditarAreaComponent],
  providers: [ComumService, ComumHttpService, CookieService]
})
export class ComumModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/comum.module.ts